import React from 'react';

import { TextArea } from '@tcc/crate';

import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';

type RegionNoteFormCommentProps = {
  note: string;
  setNote: (string) => void;
};

export const RegionNoteFormComment = ({
  note,
  setNote
}: RegionNoteFormCommentProps) => (
  <>
    <div className={styles.regionCommentHeader}>
      {getMessage('scouting.form.note.singular')}
    </div>
    <TextArea
      className={styles.regionNoteTextArea}
      data-test-id="region-note-form-field-note"
      maxLength="4000"
      name="note"
      onChange={({ target: { value } }) => setNote(value)}
      placeholder={getMessage('scouting.form.addNote')}
      value={note}
    />
  </>
);
